import React from 'react';
import PropTypes from 'prop-types';

import { contentSvgs } from 'assets/icons';

import * as S from './styles';

const Slider = ({
  data, children, currentname, currentIndex, setSelectedIndex,
}) => {
  const changeDataIndex = (index) => {
    setSelectedIndex(index);
  };

  const nextIndex = () => {
    if (currentIndex + 1 > data?.length - 1) return data?.length - 1;

    return setSelectedIndex(current => current + 1);
  };

  const previousIndex = () => {
    if (currentIndex === 0) return 0;

    return setSelectedIndex(current => current - 1);
  };

  return (
    <S.Container>
      <S.Header>
        <S.IndexName>{currentname}</S.IndexName>
        <S.Dots>
          {data.map((_, index) => (
            <S.Dot
              className={currentIndex === index ? 'selected' : ''}
              onClick={() => changeDataIndex(index)}
            />
          ))}
        </S.Dots>
      </S.Header>
      <S.Content>
        {children}
        <S.ArrowLeft
          onClick={previousIndex}
          disabled={currentIndex === 0}
        >
          {contentSvgs('slideArrow')}
        </S.ArrowLeft>
        <S.ArrowRight
          onClick={nextIndex}
          disabled={currentIndex + 1 > data?.length - 1}
        >
          {contentSvgs('slideArrow')}
        </S.ArrowRight>
      </S.Content>
    </S.Container>
  );
};

export default Slider;

Slider.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape(PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]))).isRequired,
  children: PropTypes.node.isRequired,
  currentname: PropTypes.string.isRequired,
  currentIndex: PropTypes.number.isRequired,
  setSelectedIndex: PropTypes.func.isRequired,
};
